import { BaseMapper } from '../shared/base.mapper';
import { Protocol } from '../../types/protocol/protocol.type';
import { Injectable } from "@angular/core";

@Injectable()
export class ProtocolMapper extends BaseMapper<Protocol> {

}
